import { ProfileI18n } from '@/locales/base.message.locales';

export const profile: ProfileI18n = {
  titles: {
    about: 'Sobre',
    about_you: '<h1><span>Sobre</span> você</h1>',
    achievements: 'Conquistas',
    activities: 'Atividades',
    activities_register: '<h1><span>Registro</span> de atividade</h1>',
    activities_description: 'Aqui é onde são registradas todas as suas atividades na plataforma, por exemplo quando começou a participar de um desafio ou quando o mesmo foi concluido.',
    bio: 'Bio',
    no_bio: 'Para que outros usuários possam lhe conheçer melhor, vá até a as configurações do seu perfil e adicione uma breve descrição sobre você. Uma boa descrição pode incluir informações sobre sua formação ou área de atuação, interesses, objetivos e o motivo de estar fazendo parte da plataforma IKONE.',
    public_no_bio: 'não possui biografia.',
    no_challenge: 'Aqui serão exibidos todos os desafios criados por você. Para criar um novo desafio na plataforma IKONE, vá até a tela inicial na seção "Eu tenho um desafio" e insira as informações do desafio e seu contato, assim uma curadoria será feita para criação do seu novo desafio.',
    no_teams: 'Nessa seção serão exibidos todos os times criados por você. Para criar um time primeiramente você deve estar participando de um desafio. A opção para criar um time estará disponível logo abaixo da opção de participar do desafio.',
    public_no_teams: 'não possui nenhum time.',
    following: 'Seguindo',
    no_following: 'Agora que você já participa da plataforma IKONE poderá seguir desafios criados por outros usuários, para serguir um desafio basta ir até a tela de desafios, clicar sobre um desafio e logo acima do nome haverá um botão escrito "SEGUIR", é só clicar e ponto ! Agora o desafio seguido ficará salvo aqui.',
    public_no_following: 'não está seguindo nenhum desafio.',
    following_challenges: '<h1><span>Desafios</span> seguidos</h1>',
    public_following_challenges: 'Desafios seguidos por',
    platform_settings: 'Configurações da plataforma',
    profile: 'Perfil',
    security: 'Segurança',
    platform_notifications: 'Notificações da Plataforma',
    change_password: 'Alterar Senha',
    change_email: 'Alterar email',
    member_since: 'Membro desde',
    upload_picture: 'CARREGAR UMA FOTO',
    view_team: 'Ver time',
    upload_progress: 'CARREGANDO ...',
    my_challenges: '<h1><span>Meus</span> Desafios</h1>',
    my_challenges_tab: 'Meus Desafios',
    my_teams: '<h1><span>Meus</span> Times</h1>',
    public_profile_teams: 'Times de',
    date_format: 'Formato: yyyy-mm-dd',
    no_skills: 'Usuário não possui habilidades cadastradas.',
    visit_profile: 'Visitar perfil',
    membership_card: 'Cartão do membro',
    certificates: 'Certificados',
    access_linkedin: 'Visitar Linkedin',
    lives_helped: 'Ajudou mais de um milhão de vidas'
  },
  messages: {
    update_failed: 'Falhou ao atualizar os seus dados',
    update_success: 'Dados atualizados com sucesso',
    complete_your_profile: 'Por favor, complete o seu perfil antes',
    email_successfully_checked: 'Agora você já pode participar de desafios, interagir nos fôruns e criar times..  Vamos mudar o mundo juntos?',
    complete_profile: 'Por favor, complete seu perfil!',
    no_achievements: 'Não possui conquistas'
  },

  platform_settings: {
    all_challenges: {
      new: 'Novos Desafios',
      title: 'Todos os desafios',
    },
    my_challenges: {
      forum: 'Forum',
      tasks: 'Tarefas',
      title: 'Meus desafios',
      update: 'Atualizações',
    },
    chat: {
      messages: 'Mensagens',
      title: 'Chat',
    },
    email: 'Email',
    email_frequency: {
      always: 'Sempre',
      title: 'Frequencia de notificações por email',
    },
    language: 'Idioma',
    platform: {
      check: 'Plataforma',
      ikone_notifications: 'Notificações do Ikone',
      title: 'Plataforma',
    },
    timezone: 'Fuso horário',
  },
};
